import MyLayout from '../../components/Layout'

function Admin() {
    return <MyLayout></MyLayout>
}

export default Admin
